export default __webpack_public_path__ + "static/media/b4-dot-6.4cfd87ca.png";